import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-[#0A2540] border-t border-white/10 text-slate-400 py-10">
    <div className="px-6 md:px-10 lg:px-14 xl:px-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <img
          src="https://customer-assets-7cd3h4nn.emergentagent.net/job_akr-renders/artifacts/wu6mc57m_image.png"
          alt="AKR Steel Detailing Services LLC"
          className="h-14 w-auto object-contain"
          style={{
            filter: "invert(1) hue-rotate(180deg) brightness(1.15) contrast(1.05)",
          }}
        />
      </div>
      <div className="text-xs font-mono uppercase tracking-[0.2em]">
        © {new Date().getFullYear()} AKR Steel Detailing Services LLC
      </div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs">
        <a href="/#gallery" className="hover:text-white transition-colors">Structures</a>
        <Link to="/what-we-do" className="hover:text-white transition-colors">What We Do</Link>
        <a href="/#capabilities" className="hover:text-white transition-colors">Capabilities</a>
        <a href="/#contact" className="hover:text-white transition-colors">Contact</a>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="hover:text-white transition-colors"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  </footer>
);
